import { CONFIG_TAB_IDS, type FeatureKey } from "./feature-keys";

const BASE_PERMISSION_DEPENDENCIES: readonly (readonly [
	dependent: FeatureKey,
	required: FeatureKey,
])[] = [
	["chat:reply", "chat:view"],
	["calendar:edit", "calendar:view"],
	["contacts:edit", "contacts:view"],
	["documents:edit", "documents:view"],
	["campaigns:manage", "campaigns:view"],
	["templates:manage", "templates:view"],
	["waitlist:manage", "waitlist:view"],
];

const CONFIG_PERMISSION_DEPENDENCIES = CONFIG_TAB_IDS.map(
	(id) =>
		[`config:tab:${id}:edit`, `config:tab:${id}:view`] as readonly [
			FeatureKey,
			FeatureKey,
		]
);

export const PERMISSION_DEPENDENCIES: readonly (readonly [
	dependent: FeatureKey,
	required: FeatureKey,
])[] = [...BASE_PERMISSION_DEPENDENCIES, ...CONFIG_PERMISSION_DEPENDENCIES];

/** Frontend mirror of the server's permission-write normalization. */
export function normalizePermissionWrite(
	permissions: Readonly<Record<string, boolean>>
): Record<string, boolean> {
	const normalized = { ...permissions };
	for (const [dependent, required] of PERMISSION_DEPENDENCIES) {
		if (normalized[required] === false && normalized[dependent] === true) {
			normalized[dependent] = false;
		}
	}
	for (const [dependent, required] of PERMISSION_DEPENDENCIES) {
		if (normalized[dependent] === true) {
			normalized[required] = true;
		}
	}
	return normalized;
}
